export const coerceNumber = (value: unknown): number => {
  if (!['string', 'number'].includes(typeof value)) {
    return NaN;
  }

  return parseInt(String(value), 10);
};
